// extracted by mini-css-extract-plugin
module.exports = {"Menu":"bhe_a bhs_h","Menu__offsetParent":"bhe_b bhs_bj","Menu__trigger--shadowed":"bhe_c"};